module.exports = __webpack_public_path__ + "media/images/magnet-5f41821bc56144e80809feb2d6d30b60.png";